import type {PostApiModel} from '../../../../api/channel/post';
import type {FileApiModel} from '../../../../api/media/file';
import type {ApiRpcQuery} from '../../../../api/utils/apiRequest';
import type {AttachmentType} from './types';

export const getAttachmentTypeByType = (
  type: AttachmentType,
): FileApiModel['type'] => {
  if (type === 'url') {
    return 'url';
  }

  return 'file';
};

export const getCategoriesByType = (type: AttachmentType) => {
  let categories: string[] = [];

  switch (type) {
    case 'audio':
      categories = ['audio'];
      break;
    case 'document':
      categories = ['document', 'text'];
      break;
    case 'image':
      categories = ['image'];
      break;
    case 'url':
      categories = ['website'];
      break;
    default:
      break;
  }

  return categories;
};

export const buildQuery = (
  type: AttachmentType,
): ApiRpcQuery<PostApiModel>[] | undefined => {
  let attachmentType: FileApiModel['type'] = 'file';

  if (type === 'url') {
    attachmentType = 'url';
  }

  return [
    // @ts-expect-error: TODO: describe why
    ['attachments.type', '==', attachmentType],
    // @ts-expect-error: TODO: describe why
    ['attachments.categories', 'contains', getCategoriesByType(type)],
  ];
};
